export enum ModalKind {
    GENERAL = "general",
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
    SERIOUS_WARNING = "serious-warning",
}

export enum ModalSize {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
}
